import React from 'react';
import EyeIcon from './../../../components/EyeIcon/EyeIcon';

export default function EyeIconExample() {
  return <EyeIcon />;
}



// WEBPACK FOOTER //
// ./src/docs/examples/EyeIcon/Example.js